import { render } from "./Pet.vue?vue&type=template&id=ff484906"
import script from "./Pet.vue?vue&type=script&lang=js"
export * from "./Pet.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__